<div class="approval-workflow-root">
  @if (!isCreateMode && showRegenerateButton) {
    <button
      type="button"
      id="btn-regenerate-approval-workflow"
      data-id="btn-regenerate-approval-workflow"
      class="btn btn-standard regenerate-btn"
      appBlurOnModalClose
      (click)="onRegenerate()"
    >
      <em class="icon-refresh"></em> Regenerate Approval Workflow
    </button>
  }

  <div
    class="approval-workflow-scroll"
    [class.top]="isCreateMode"
    [class.create-mode]="isCreateMode"
    appWheelHorizontalScroll
  >
    <div class="approval-workflow-container" [class.create-mode]="isCreateMode">
      <div class="requester-column">
        <app-requester-card
          [requesterType]="requesterType"
          [requestedDate]="requesterDate"
          [storeName]="storeName"
          [isCreateMode]="isCreateMode"
          [requesterName]="
            (approvalWorkflow?.requesterFirstName || '') + ' ' + (approvalWorkflow?.requesterLastName || '')
          "
        ></app-requester-card>

        <app-note-to-approver-card
          [isCreateMode]="isCreateMode"
          [noteText]="noteText"
          (noteTextChange)="onNoteChange($event)"
        ></app-note-to-approver-card>
      </div>

      @if (displayStepCards.length) {
        <div class="connector-width-x">
          <div class="line-right-arrow"></div>
        </div>

        @for (card of displayStepCards; track $index) {
          <app-step-card [card]="card"></app-step-card>

          @if (!$last) {
            <div class="connector-width-x">
              <div class="line-right-arrow"></div>
            </div>
          }
        }

        <div class="connector-width-x">
          <div class="line-right-arrow"></div>
        </div>

        <div class="completed-badge" [class.complete]="activeFlowComplete">Completed</div>
      }
    </div>
  </div>
</div>
